import { observable, computed, action, makeObservable/*, toJS*/ } from "mobx";

class MenuStore {

    constructor() {
        makeObservable(this);
    }

    @observable
    _st_menu_code = "";


    get getMenuCode() {
        return this._st_menu_code;
    }

    @action
    setMenuCode(menu_code) {
        this._st_menu_code = menu_code;
    }

    @observable
    _st_menu_group_code = null;


    get getMenuGroupCode() {
        return this._st_menu_group_code;
    }

    @action
    setMenuGroupCode(groupCode) {
        this._st_menu_group_code = groupCode;
    }

    /*********************/
    /* 메뉴 목록 리스트     */
    /*********************/
    /**
     * 메뉴 목록 객체 OBJ LIST
     * @type {[]}
     * @private
     */
    @observable
    _st_menu_list = []

    /**
     * 메뉴 목록 조회
     * @returns {[]}
     */
    @computed
    get getMenuList() {
        return this._st_menu_list;
    }

    @action
    initMenuList() {
        this._st_menu_list = [];
    }

    @action
    setMenuList(obj) {
        this._st_menu_list = obj;
    }

    /*********************/
    /* 메뉴 상세 내용      */
    /*********************/
    /**
     * 메뉴 상세 객체 OBJ
     * @type {[]}
     * @private
     */
    @observable
    _st_menu_detail = {};

    /**
     * 메뉴 상세
     * @returns {[]}
     */
    @computed
    get getMenuDetail() {
        return this._st_menu_detail;
    }

    @action
    initMenuDetail() {
        this._st_menu_detail = {};
    }

    @action
    setMenuDetail(obj) {
        this._st_menu_detail = obj;
    }

    /**
     * side menu checkbox checked
     * @returns {[]}
     */
    @observable
    _st_side_menu_checked = [];

    @computed
    get getSideMenuChecked() {
        return this._st_side_menu_checked;
    }

    @action
    initSideMenuChecked() {
        this._st_side_menu_checked = [];
    }

    @action
    setSideMenuChecked(obj) {
        this._st_side_menu_checked = [...this._st_side_menu_checked, obj];
    }

    /*********************/
    /* 메뉴 Data          */
    /*********************/
    /**
     * 메뉴 DATA Array
     * @type {[]}
     * @private
     */
    @observable
    _st_menu_data = []

    /**
     * 메뉴 DATA
     * @returns {[]}
     */
    @computed
    get getMenuData() {
        return this._st_menu_data;
    }

    @action
    initMenuData() {
        this._st_menu_data = [];
    }

    @action
    setMenuData(obj) {
        this._st_menu_data = obj;
    }

    @action
    updateSoldOut(soldOut) {
        this._st_menu_data = this._st_menu_data.map(menuData=> {
            let menuList = menuData.prods.map(menuList=> {
                if(menuList.prodCd === this._st_menu_soldOut_code){
                    if(Array.isArray(menuList.sdsList) && menuList.sdsList.length > 0){
                        let sideMenuList = this.updateSideSoldOut(menuList.sdsList, soldOut)
                        return {...menuList, soldOut: (soldOut)?"Y":"N", sdsList: sideMenuList}
                    }
                    return {...menuList, soldOut: (soldOut)?"Y":"N"}
                }else{
                    if(Array.isArray(menuList.sdsList) && menuList.sdsList.length > 0){
                        let sideMenuList = this.updateSideSoldOut(menuList.sdsList, soldOut)
                        return {...menuList, sdsList: sideMenuList}
                    }
                    return menuList
                }
            })
            return {...menuData, prods: menuList}
        })
        //menu detail store change!!
        this.updateMenuDetail();
    }

    updateSideSoldOut(sideList, soldOut){

        let sideMenuGroup = sideList.map(sideMenuGrup=>{
            let sideMenu = null;
            if(Array.isArray(sideMenuGrup.sdsProdList) && sideMenuGrup.sdsProdList.length > 0) {
                sideMenu = sideMenuGrup.sdsProdList.map(sideMenu => {
                    if(sideMenu.prodCd === this._st_menu_soldOut_code){
                        return {...sideMenu, soldOut: (soldOut)?"Y":"N"}
                    }else{
                        return sideMenu
                    }
                })
            }
            return {...sideMenuGrup, sdsProdList: sideMenu}
        })
        return sideMenuGroup
    }

    updateMenuDetail(){
        this._st_menu_data.map(menuData=>{
            if(this._st_menu_group_code === menuData.tuClsCd ){
                menuData.prods.map(menuList=>{
                    if(this._st_menu_code === menuList.prodCd){
                        this.setMenuDetail(menuList);
                    }
                })
            }
        })
    }

    @observable
    _st_menu_soldOut_code = "";

    @computed
    get getMenuSoldOutCode() {
        return this._st_menu_soldOut_code;
    }

    @action
    setMenuSoldOutCode(checkBoxId) {
        this._st_menu_soldOut_code = checkBoxId;
    }

    /**
     * 메뉴 목록 객체 OBJ LIST
     * @type {[]}
     * @private
     */
    @observable
    _st_incomplete_menu_list = []

    @computed
    get getIncompleteMenuList() {
        return this._st_incomplete_menu_list;
    }

    @action
    setIncompleteMenuList(obj) {
        this._st_incomplete_menu_list = obj;
    }

    //처리중주문개수
    @observable
    _st_incomplete_menu_cnt = "";

    @computed
    get getIncompleteMenuCnt() {
        return this._st_incomplete_menu_cnt;
    }

    @action
    setIncompleteMenuCnt(val) {
        this._st_incomplete_menu_cnt = val;
    }

}

export default new MenuStore();